module.exports = __webpack_public_path__ + "media/images/logos/cyclebar-logo-f1a6eecbccfc729aedd9769e009ca151.svg";